/***************************************************************************************************
** Sort Utilities
***************************************************************************************************/

// Parses a single sort string (e.g. "first_name asc") into a { key, direction } entry
const parseEntry = (entry) => {
  const trimmed = entry.trim();
  if (!trimmed) return null;

  const parts = trimmed.split(/\s+/);
  if (parts.length < 2) return null;

  const direction = parts.at(-1);
  const key = parts.slice(0, -1).join("_");

  return { key, direction };
};

// Extracts and parses the sort value (params.s) into an array of { key, direction } entries
const getEntriesFromParams = (params) => {
  if (!params) return [];

  const value = params.s;

  if (!value) return [];
  if (typeof value === "string") return [parseEntry(value)].filter(Boolean);
  if (Array.isArray(value)) return value.map(parseEntry).filter(Boolean);

  return [];
};

// Serializes an array of entries back into the param format for URL/API usage
const serializeEntries = (entries) => {
  if (!entries || entries.length === 0) return null;

  const serialized = entries.map((entry) => `${entry.key} ${entry.direction}`);
  return serialized.length === 1 ? serialized[0] : serialized;
};

// Finds a sort entry by key and returns it with its 1-based position
const findEntry = (entries, sortKey) => {
  const index = entries.findIndex((entry) => entry.key === sortKey);
  if (index === -1) return null;

  return { ...entries[index], position: index + 1 };
};

// Returns the next sort entries after toggling a column: none → asc → desc → default
const nextEntriesForColumn = (currentEntries, sortKey, defaultEntries) => {
  const existing = currentEntries.find((entry) => entry.key === sortKey);

  if (!existing) return [{ key: sortKey, direction: "asc" }];
  if (existing.direction === "asc") return [{ key: sortKey, direction: "desc" }];

  if (areEntriesEqual(currentEntries, defaultEntries)) {
    return [{ key: sortKey, direction: "asc" }];
  }

  return defaultEntries;
};

// Compares two arrays of sort entries for equality (same keys and directions in order)
const areEntriesEqual = (entries1, entries2) => {
  if (entries1.length !== entries2.length) return false;

  return entries1.every((entry, index) => {
    const otherEntry = entries2[index];

    return entry.key === otherEntry.key && entry.direction === otherEntry.direction;
  });
};

export default {
  parseEntry,
  getEntriesFromParams,
  serializeEntries,
  findEntry,
  nextEntriesForColumn,
  areEntriesEqual,
};
